var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 20.125C6.56445 20.125 6.22223 19.8088 6.22223 19.4062V6.46875C6.22223 6.06625 6.56445 5.75 7.00001 5.75C7.43556 5.75 7.77778 6.06625 7.77778 6.46875V19.4062C7.77778 19.8088 7.43556 20.125 7.00001 20.125Z",
    fill: "#2C2C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4444 10.7812C12.3424 10.7824 12.2413 10.7638 12.1475 10.7266C12.0538 10.6895 11.9694 10.6346 11.9 10.5656L6.99998 6.03747L2.09998 10.5656C1.78887 10.8531 1.30665 10.8531 0.99554 10.5656C0.684429 10.2781 0.684429 9.83247 0.99554 9.54497L6.43998 4.51372C6.7511 4.22622 7.23332 4.22622 7.54443 4.51372L12.9889 9.54497C13.3 9.83247 13.3 10.2781 12.9889 10.5656C12.8333 10.7093 12.6311 10.7812 12.4444 10.7812Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitButton);
export default __webpack_public_path__ + "static/media/submit-button.f215c1b8d75b7b1c42a6dc0a0dc30c27.svg";
export { ForwardRef as ReactComponent };